import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BOOK } from "../data/book";
import { useLang } from "../i18n";
import api from "../api";

const Footer = () => {
  const { t } = useLang();
  const [co, setCo] = useState(null);

  useEffect(() => {
    api.get("/company").then(({ data }) => setCo(data)).catch(() => {});
  }, []);

  const legal = co
    ? `${co.name} · ${co.country} · P.IVA ${co.vat}`
    : "EI SRL · Italia · P.IVA 16017671005";

  return (
    <footer className="relative border-t border-white/10 overflow-hidden" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">
        <Link to="/libro-online" data-testid="footer-book-online-cta"
          className="group flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-2xl border border-ember/40 bg-ember/5 px-6 py-5 mb-12 hover:bg-ember/10 hover:border-ember transition-colors">
          <div>
            <p className="font-mono2 text-[10px] tracking-[0.3em] uppercase text-ember mb-1.5">{t("bo_kicker")}</p>
            <p className="font-display font-bold text-lg">{t("footer_book_online")}</p>
            <p className="text-sm text-mute mt-1">{t("footer_bo_desc")}</p>
          </div>
          <span className="inline-flex items-center gap-2 shrink-0 self-start sm:self-center rounded-full bg-ember px-6 py-2.5 text-xs font-semibold uppercase tracking-wider text-black group-hover:bg-gold transition-colors">
            {t("bo_cta")} <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <div className="flex items-center gap-2 text-ember mb-3">
              <img src="/img/logo-mark.png" alt="" className="w-4 h-4 rounded" />
              <span className="font-mono2 text-xs tracking-[0.3em] uppercase">{t("footer_tag")}</span>
            </div>
            <p className="font-serif-it text-2xl text-mist max-w-md">
              «{t("hero_sub")}»
            </p>
          </div>
          <nav className="flex gap-8 text-sm">
            <Link to="/storie" data-testid="footer-link-stories" className="text-mist hover:text-ember transition-colors">{t("nav_stories")}</Link>
            <Link to="/autore" data-testid="footer-link-author" className="text-mist hover:text-ember transition-colors">{t("nav_author")}</Link>
            <Link to="/sponsor" data-testid="footer-link-sponsor" className="text-mist hover:text-gold transition-colors">{t("footer_sponsor")} EI SRL</Link>
          </nav>
        </div>
        <h2 className="font-display font-extrabold uppercase leading-none tracking-tight text-[13vw] text-white/5 select-none mt-12 -mb-4">
          Una vita da DJ
        </h2>
        <div className="flex flex-col sm:flex-row justify-between gap-2 border-t border-white/10 pt-6 text-xs text-mute font-mono2 tracking-wider uppercase">
          <span>© {BOOK.year} {BOOK.author} · {BOOK.publisher}</span>
          <span data-testid="footer-legal">{legal} — {t("footer_rights")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
